import { render, staticRenderFns } from "./group-form.vue?vue&type=template&id=20c33f67&scoped=true"
import script from "./group-form.vue?vue&type=script&lang=js"
export * from "./group-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c33f67",
  null
  
)

export default component.exports